/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import { connect } from 'react-redux';

import history from '../../../history';
import actions from '../../../actions';
import { createMassBookingAsync } from '../../../actions/MassBooking';
import FreelancersTable from './table';
import { withRefreshTableOnFilterChange } from '../common/decorators';
import { MASS_BOOKING_MODE, SERIES_BOOKING_MODE } from '../../../consts';


const MIN_SEARCH_LEN = 3;

@withRefreshTableOnFilterChange
class Freelancers extends Component {
    componentDidMount() {
        const currentUrlParams = new URLSearchParams(history.location.search);

        // second parameter is needed to trigger isInitialLoad
        this.props.load(currentUrlParams, true);

        if (
            (history.location.search.includes(MASS_BOOKING_MODE) &&
            !this.props.selectedJobs.length) ||
            (history.location.search.includes(SERIES_BOOKING_MODE) &&
            !this.props.selectedSeries)
        ) {
            history.push('freelancers?is_archived=false');
        }
    }

    render() {
        let pages = -1;
        let showPaginationBottom = false;

        if (this.props.content && this.props.meta) {
            pages = Math.ceil(this.props.meta.count / 20);
            showPaginationBottom = this.props.meta.count > 20;
        }

        const currentUrlParams = new URLSearchParams(history.location.search);

        return (
            <FreelancersTable
                data={this.props.content}
                pages={pages}
                showPaginationBottom={showPaginationBottom}
                loading={this.props.fetching}
                notification={this.props.notification}
                user={this.props.user}
                meta={this.props.meta}
                location={this.props.location}
                history={history}
                uploadingFreelancers={this.props.uploadingFreelancers}
                reloadData={() => {
                    this.props.load(currentUrlParams);
                }}
                selectedFreelancers={this.props.selectedFreelancers}
                setSelectedFreelancers={this.props.setSelectedFreelancers}
                selectedJobs={this.props.selectedJobs}
                selectedSeries={this.props.selectedSeries}
                createMassBooking={this.props.createMassBooking}
                createMassBookingAsync={this.props.createMassBookingAsync}
                massBookingResults={this.props.massBookingResults}
                massBookingResultsError={this.props.massBookingResultsError}
                isMassBookingCreating={this.props.isMassBookingCreating}
            />
        );
    }
}

const mapStateToProps = state => ({
    ...state.freelancers,
    user: state.user,
    uploadingFreelancers: state.uploadingFreelancers,
    selectedFreelancers: state.freelancers.selectedFreelancers,
    selectedJobs: state.shifts.selectedJobs,
    selectedSeries: state.series.selectedSeries,
    massBookingResults: state.freelancers.massBookingResults,
    massBookingResultsError: state.freelancers.massBookingResultsError,
    isMassBookingCreating: state.loading?.massBooking,
});

const mapDispatchToProps = dispatch => ({
    load: (searchParams, isInitialLoad = false) => {
        const searchValue = searchParams.get('search');

        if (isInitialLoad || !searchValue || searchValue.length >= MIN_SEARCH_LEN) {
            dispatch(actions.loadFreelancers(searchParams));
        }
    },
    setSelectedFreelancers: items =>
        dispatch(actions.setSelectedFreelancers(items)),
    createMassBookingAsync: (
        massBookingPayload,
        isInvite,
        axiosAbortController,
    ) =>
        dispatch(
            createMassBookingAsync(
                massBookingPayload,
                isInvite,
                axiosAbortController,
            ),
        ),
    createMassBooking: () => dispatch(actions.createMassBooking()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Freelancers);
